import * as React from 'react';
import Immutable from 'immutable';
import {useSelector} from 'react-redux';
import {Trans} from '@lingui/macro';

import FlatButton from '@components/FlatButton';
import EscIcon from '@components/Icons/CloseIcon';
import BellIcon from '@components/Icons/BellIcon';

import s from './ChatPreview.module.css';

export default function ChatPreview({close, startTest, test}) {
  const previewMetadata =
    test.getIn(['jsonData', 'theme', 'preview']) ||
    Immutable.fromJS({
      tag: '',
      preview: {
        img: {
          alt: 'Silvia Fantini',
          src: '/storage/themes/calendar/calendar-avatar.png',
        },
        type: 'chat',
        sender: 'Silvia Fantini',
        messages: ['Hello {{firstName}}', 'placeholder message'],
      },
      duration: '15 Min',
    });

  const firstName = useSelector(state => state.getIn(['user', 'data', 'firstName']));

  return (
    <>
      <div className={s.Container}>
        <div className={s.Header}>
          <div className={s.MailIcon}>
            <BellIcon />
            <div>
              <Trans id="calendar.preview_message">Messaggio della tua assistente</Trans>
            </div>
          </div>

          <FlatButton onClick={close}>
            <EscIcon customColor={true} />
          </FlatButton>
        </div>

        <div className={s.Body}>
          <div className={s.Mail}>
            <div className={s.Name}>
              <div className={s.Img}>
                {previewMetadata.getIn(['img', 'src']) ? (
                  <img
                    src={previewMetadata.getIn(['img', 'src'])}
                    alt={previewMetadata.getIn(['img', 'alt'])}
                  />
                ) : (
                  <div className={s.Placeholder} />
                )}
              </div>

              <div>{previewMetadata.get('sender')}</div>
            </div>
            <div className={s.Chat}>
              {previewMetadata.get('messages').map((message, index) => (
                <div
                  key={index}
                  className={s.Bubble}
                  dangerouslySetInnerHTML={{__html: message.replace('{{firstName}}', firstName)}}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <FlatButton className={s.Footer} onClick={startTest}>
        <Trans id="calendar.preview_start">Inizia attività</Trans>
      </FlatButton>
    </>
  );
}
